import { GameReplicatedTimeout, GameReplicatedTimeoutConfig } from "../../../core/game/server/GameReplicatedTimeout";
import { createReplicatedLock } from "../../../core/game/server/ReplicatedLock";
import { getAnnouncementBannerTime } from "../../../front/core/util/BannerTimelineConstants";
import { Contact3DLock } from "../Contact3DLock";
import { createDeleteClueTimeout } from "./DeleteClueTimeout";
class AnswerResultTimeout extends GameReplicatedTimeout {
    callback() {
        var _a;
        const { isGameOver, answerWasCorrect, answeredBySecretWordGiver, answer, sourceId, sourceUsername, } = this.data;
        const { gameState, players, commitEndGame } = this.context;
        gameState.addPreviousClue(answer);
        gameState.commitNewGuess(sourceId, sourceUsername, answer);
        if (answerWasCorrect) {
            const playerRecord = players.data.record[sourceId];
            if (playerRecord !== undefined) {
                players.commitPlayerRecordData(playerRecord.playerId, {
                    score: playerRecord.score + (answeredBySecretWordGiver ? 10 : 20),
                });
            }
        }
        if (!isGameOver && answeredBySecretWordGiver && answerWasCorrect) {
            gameState.commitData({
                currentAdjustment: gameState.getClampedIncrementedAdjustment(-1),
            });
        }
        if (isGameOver || !answeredBySecretWordGiver || answerWasCorrect) {
            this.scheduleCommitDelete();
        }
        // End game if needed
        if (isGameOver) {
            commitEndGame({
                gameEndReason: 'GameFinished',
                details: {
                    winner: 'Guessers',
                    secretWord: (_a = gameState.data.secretWord) !== null && _a !== void 0 ? _a : '',
                }
            });
        }
        // Grant an extra letter if needed
        else if (answerWasCorrect && !answeredBySecretWordGiver) {
            gameState.commitData({
                // End game early if answer is the secret word
                numRevealedLetters: gameState.data.numRevealedLetters + 1,
                currentAdjustment: gameState.getClampedIncrementedAdjustment(1),
            });
        }
    }
    scheduleCommitDelete() {
        const { answerWasCorrect, answeredBySecretWordGiver, isGameOver, clueId, } = this.data;
        const willShowNewLetterBanner = answerWasCorrect && !answeredBySecretWordGiver && !isGameOver;
        if (willShowNewLetterBanner) {
            createReplicatedLock({
                key: Contact3DLock.AnswerSubmissionLock,
                durationMs: getAnnouncementBannerTime(),
            }, this.context);
            createDeleteClueTimeout({
                clueId,
                durationMs: getAnnouncementBannerTime(),
            }, this.context);
        }
        else {
            const clue = this.context.getReplicatedObjectById(this.data.clueId);
            clue.commitDelete();
        }
    }
}
export function createAnswerResultTimeout(data, context) {
    return context.createReplicatedTimeout('AnswerResultTimeout', data, [data.clueId]);
}
export const AnswerResultTimeoutConfig = new GameReplicatedTimeoutConfig('AnswerResultTimeout', AnswerResultTimeout);
//# sourceMappingURL=AnswerResultTimeout.js.map